export class ProductionLogIdRequest{
    productionLogId:number;
    constructor(productionLogId:number){
        this.productionLogId = productionLogId;
    }
}